import React, { lazy, Suspense, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Nav from "./components/Nav/Nav";
// import Loading from "./components/Loading/Loading";
import LoadingScale from "./components/LoadingScale/LoadingScale";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./ScrollToTop";

const Home = lazy(() => import("./pages/Home"));
const MKLPayment = lazy(() => import("./pages/MKLPayment"));
const MKLPaymentSuccess = lazy(() => import("./pages/MKLPaymentSuccess"));
const ClubLogin = lazy(() => import("./pages/ClubLogin"));
const Account = lazy(() => import("./pages/Account"));
const Selectedteam = lazy(() => import("./pages/Selectedteam"));
const ForgotPass = lazy(() => import("./pages/ForgotPass"));

const Router = () => {
  const [activeLt, setActiveLt] = useState(true);
  const [activeEn, setActiveEn] = useState(false);
  function RequireAuth({ children }) {
    const token = localStorage.getItem("mklusertoken");
    let location = useLocation();

    if (!token) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    return children;
  }
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingScale />}>
        <Nav
          setActiveEn={setActiveEn}
          activeEn={activeEn}
          setActiveLt={setActiveLt}
          activeLt={activeLt}
        />
        <ScrollToTop />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Home
                setActiveEn={setActiveEn}
                activeEn={activeEn}
                setActiveLt={setActiveLt}
                activeLt={activeLt}
              />
            }
          />
          <Route
            exact
            path="/mklentryfee"
            element={
              <MKLPayment
                setActiveEn={setActiveEn}
                activeEn={activeEn}
                setActiveLt={setActiveLt}
                activeLt={activeLt}
              />
            }
          />
          <Route
            exact
            path="/mklentryfee/success"
            element={
              <MKLPaymentSuccess
                setActiveEn={setActiveEn}
                activeEn={activeEn}
                setActiveLt={setActiveLt}
                activeLt={activeLt}
              />
            }
          />
          <Route
            exact
            path="/clublogin"
            element={
              <ClubLogin
                setActiveEn={setActiveEn}
                activeEn={activeEn}
                setActiveLt={setActiveLt}
                activeLt={activeLt}
              />
            }
          />
          <Route
            exact
            path="/clublogin/account"
            element={
              <RequireAuth>
                <Account
                  setActiveEn={setActiveEn}
                  activeEn={activeEn}
                  setActiveLt={setActiveLt}
                  activeLt={activeLt}
                />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/clublogin/account/selectedteam"
            element={
              <RequireAuth>
                <Selectedteam
                  setActiveEn={setActiveEn}
                  activeEn={activeEn}
                  setActiveLt={setActiveLt}
                  activeLt={activeLt}
                />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/clublogin/forgotpassword"
            element={
              <ForgotPass
                setActiveEn={setActiveEn}
                activeEn={activeEn}
                setActiveLt={setActiveLt}
                activeLt={activeLt}
              />
            }
          />
        </Routes>
        <Footer />
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
